<template>
  <div class="detail">
    <com-steps :show.sync="showCopy">
      <com-step>
        <div class="step-title">活动规则</div>
        <div class="step-detail">
          <div>活动主题：
上支付宝搜车赢现金红包

活动时间：
即日起-2018.11.30

活动玩法：
用户通过活动主页点击参与活动——进入小程序搜汽车品牌或车——进入结果页面抽现金红包

奖品设置：
10万现金红包，数量有限，领完即止

活动规则：
1）活动期间，每个用户通过搜索可以抽取1次红包
2）每天每个用户邀请好友进行搜索抽红包，还可以再抽1次红包
3）每天红包可抽次数第二天凌晨0点自动清零
4）好友重复邀请无效，已参与活动的好友不在有效受邀范围内
5）红包长期有效，直接到用户余额，可用于线上线下任何渠道的消费抵用
6）红包会在24小时内到账，可通过支付宝服务提醒查询到账情况
7）活动页面带有购车优惠券，每个用户每张券仅限领取一张
8）优惠券可在有效期内进入支付宝-卡包-券内使用

奖品说明：
1）同一身份、同一手机号、同一支付宝账户、均视为同一个用户
2）红包直接到账户余额，不可转增及共享
3）如用户出现违规行为（如作弊、诈骗等），将撤销违规用户参与活动的资格，并收回违规用户获得的福利

活动申明：
本活动权益由太平洋汽车网提供，对使用规则有任何疑问，请联系太平洋客服：020-38895471</div>
        </div>
      </com-step>
    </com-steps>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
import ComStep from '../components/step.vue'
import ComSteps from '../components/steps.vue'
export default {
  name: 'detail',
  props: {
    show: {
      type: Boolean
    }
  },
  data() {
    return {
      showCopy: false,
      scroll: ''
    }
  },
  watch: {
    show() {
      this.showCopy = this.show
    },
    showCopy() {
      if (!this.showCopy) {
        this.$emit('update:show', false)
        return
      }
      if (!this.scroll) {
        this.$nextTick(() => {
          this.scroll = new BScroll('.step-detail', {
            scrollbar: true
          })
        })
      }
    }
  },
  components: {
    ComStep,
    ComSteps
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/cs180824/components/detail.vue